/**
 * Created by: Kostja Yanch
 * Created at 7/03/2019
 * https://marvelapp.com/4g4b5dg/screen/58400387
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isNil from 'ramda/src/isNil';
import { Popup } from '@components/@core/Animations';

class HoverDropdown extends React.PureComponent {
    state = {
        opened: false,
        title: '',
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { data, getValue, placeholder } = nextProps;
        if (data.length !== 0) {
            let title = '';
            data.forEach((e, ind) => {
                title = title + getValue(e) + (data.length === ind + 1 ? '' : ', ');
            });
            return { title };
        }
        return { title: placeholder };
    }

    handleClose = () => {
        this.setState({ opened: false });
    };

    handleOpen = () => {
        if (this.props.data.length === 0 || this.props.disabled) return;
        this.setState({ opened: true });
    };

    handleClick = (e) => {
        if (!isNil(e.program)) {
            this.props.onClick(e.program);
        }
    };

    render() {
        const { className, data, align, width, height } = this.props;
        const { opened, title } = this.state;
        const container = classNames('hover-dropdown', className, opened ? 'hover' : '');
        const menu = classNames('hover-dropdown-menu', align);
        const maxHeight = height === 'auto' ? null : { maxHeight: height, overflowY: 'auto' };

        return (
            <div className={container} style={{ width }} onMouseEnter={this.handleOpen} onMouseLeave={this.handleClose}>
                <div className="hover-dropdown-toggle">{title}</div>
                <Popup className={menu} enter={10} exit={0} opened={opened} style={maxHeight}>
                    {data.map((e, index) => (
                        <div key={`hover-${this.props.getId(e)}-${index}`} className="hover-dropdown-item" onClick={() => this.handleClick(e)}>
                            {this.props.getValue(e)}
                        </div>
                    ))}
                </Popup>
            </div>
        );
    }
}

HoverDropdown.propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.any),
    disabled: PropTypes.bool,
    align: PropTypes.oneOf(['left', 'right']),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    getId: PropTypes.func,
    getValue: PropTypes.func,
};

HoverDropdown.defaultProps = {
    className: '',
    placeholder: '',
    data: [],
    disabled: false,
    align: 'left',
    width: 'auto',
    height: 'auto',
    getId: (data) => data['id'],
    getValue: (data) => data['value'],
};

export default HoverDropdown;
